import { Component, h, Prop, State } from "@stencil/core";
import classNames from "classnames";

@Component({
  tag: "f-popover",
  styleUrl: "popover.scss",
})
export class Popover {
  @Prop() buttonText = "Scale prices details";
  @Prop() hasButton = false;
  @Prop() hasHeadline = false;
  @Prop() hasCloseButton = true;
  @Prop() hasAction = false;
  @Prop() arrowPosition = "right-bottom";
  @Prop() actionLabel = "Learn more";
  @State() show = false;

  private toggleDialog(): void {
    this.show = !this.show;
  }

  render() {
    const arrowClass = classNames("m-popover", {
      [`m-popover -${this.arrowPosition} -detached`]: this.arrowPosition,
    });
    return (
      <div class="m-popover-container">
        <div class={arrowClass}>
          <div class={`a-box -floating -${this.show ? "show" : ""}`}>
            <div class="m-popover__content">
              <div class="m-popover__head">
                {this.hasCloseButton ? (
                  <f-button
                    type="button"
                    variant="tertiary"
                    onClick={() => this.toggleDialog()}
                    additionalProps={{ "aria-label": "close popover" }}
                  >
                    <f-icon icon-name="close"></f-icon>
                  </f-button>
                ) : (
                  ""
                )}
              </div>
              <div class="m-popover__paragraph">
                <slot></slot>
              </div>
              {this.hasAction ? (
                <f-button
                  type="button"
                  onClick={() => this.toggleDialog()}
                  additionalProps={{ "aria-label": "button action" }}
                >
                  {this.actionLabel}
                </f-button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        {this.hasButton && (
          <f-button
            type="button"
            variant="tertiary"
            onClick={() => this.toggleDialog()}
          >
            {this.buttonText}
          </f-button>
        )}
      </div>
    );
  }
}
